import type { Action } from "../../actions/types";

export type StoreState = {
  [key: string]: any;
};

export const initialState: StoreState = {};

export function reducer(state: StoreState = initialState, action: Action) {
  switch (action.type) {
    case "SET_WIDGET_CONFIG":
      return action.data.data;
    case "SESSION_DATA_UPDATE":
      if (!action.data.legacyWidgetCustomerData) {
        return state;
      }

      return {
        ...state,
        ...{
          customer: {
            ...state.customer,
            ...action.data.legacyWidgetCustomerData,
          },
        },
      };

    default:
      return state;
  }
}
